var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "grid"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector ",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.41309 2C2.41309 1.72386 2.63694 1.5 2.91309 1.5H7.57975C7.8559 1.5 8.07975 1.72386 8.07975 2V6.66667C8.07975 6.94281 7.8559 7.16667 7.57975 7.16667H2.91309C2.63694 7.16667 2.41309 6.94281 2.41309 6.66667V2ZM3.41309 2.5V6.16667H7.07975V2.5H3.41309ZM9.74643 2C9.74643 1.72386 9.97029 1.5 10.2464 1.5H14.9131C15.1892 1.5 15.4131 1.72386 15.4131 2V6.66667C15.4131 6.94281 15.1892 7.16667 14.9131 7.16667H10.2464C9.97029 7.16667 9.74643 6.94281 9.74643 6.66667V2ZM10.7464 2.5V6.16667H14.4131V2.5H10.7464ZM2.41309 9.33334C2.41309 9.0572 2.63694 8.83334 2.91309 8.83334H7.57975C7.8559 8.83334 8.07975 9.0572 8.07975 9.33334V14C8.07975 14.2762 7.8559 14.5 7.57975 14.5H2.91309C2.63694 14.5 2.41309 14.2762 2.41309 14V9.33334ZM3.41309 9.83334V13.5H7.07975V9.83334H3.41309ZM9.74643 9.33334C9.74643 9.0572 9.97029 8.83334 10.2464 8.83334H14.9131C15.1892 8.83334 15.4131 9.0572 15.4131 9.33334V14C15.4131 14.2762 15.1892 14.5 14.9131 14.5H10.2464C9.97029 14.5 9.74643 14.2762 9.74643 14V9.33334ZM10.7464 9.83334V13.5H14.4131V9.83334H10.7464Z",
  fill: "#FFFFFF"
}));

function SvgCategoryManage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryManage);
export default __webpack_public_path__ + "static/media/category-manage.c5cc0c00.svg";
export { ForwardRef as ReactComponent };